const arrow = (color: string) =>
  `<?xml version="1.0" encoding="UTF-8"?>
  <svg width="12px" height="7px" viewBox="0 0 12 7" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <!-- Generator: Sketch 47.1 (45422) - http://www.bohemiancoding.com/sketch -->
      <title>Chevron-Grey Copy</title>
      <desc>Created with Sketch.</desc>
      <defs></defs>
      <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="arrow" transform="translate(-788.000000, -175.000000)" stroke-width="1.5" stroke="${color}">
              <g id="Mini-Menu" transform="translate(566.000000, 169.000000)">
                  <g id="Icon/Chevron/Blue" transform="translate(220.000000, 1.000000)">
                      <polyline id="Rectangle-Copy" transform="translate(8.000000, 5.500000) rotate(-315.000000) translate(-8.000000, -5.500000) " points="11.8890873 1.6109127 11.8890873 9.3890873 4.1109127 9.3890873"></polyline>
                  </g>
              </g>
          </g>
      </g>
  </svg>`;

export default arrow;
